import axios from '@axios'

const PREFIX = '/envio-automatico'

export default {
  getConfigs() {
    return axios.get(`${PREFIX}`)
  },

  salvarConfig(config) {
    return axios.post(`${PREFIX}`, config)
  },

  salvarEmpresas(tipoRotina, empresasIds) {
    return axios.put(`${PREFIX}/${tipoRotina}/empresas`, empresasIds)
  },

  getLogs(tipoRotina) {
    return axios.get(`${PREFIX}/log/${tipoRotina}`)
  },

  getHistoricoEnvios(tipoRotina) {
    return axios.get(`${PREFIX}/historico-envios/${tipoRotina}`)
  },

  getEmpresasParaVinculo() {
    return axios.get('/usuarios/empresas')
  },

  getFiltroCustomResumido() {
    return axios.get('filtro-customizado/resumido')
  },

  getFiltroCustomById(id) {
    return axios.get(`filtro-customizado/${id}`)
  },

  salvarFiltroCustom(filtro) {
    return axios.post('filtro-customizado', filtro)
  },

  deleteFiltroCustom(filtroId) {
    return axios.delete(`filtro-customizado?filtroId=${filtroId}`)
  },

  getUsuariosFiltro() {
    return axios.get('filtro-customizado/usuarios-filtro')
  },

  getTotalEmpresas() {
    return axios.get('filtro-customizado/empresas')
  },

  getTotalEmpresasFiltrado(body) {
    return axios.post('filtro-customizado/empresas', body)
  },
}
